import React from "react"
import styled from "@emotion/styled"
import Form from "../block/Form"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 160px 0;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  text-align: center;
`
const Title = styled.h1``
const TextContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  p {
    margin-bottom: 0;
    max-width: 480px;
  }
`
const ContactDetails = styled.div`
  display: grid;
  margin-top: 64px;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
`
const ContactTitle = styled.p`
  text-align: center;
  font-weight: 600;
  font-size: 1.2rem;
  padding-bottom: 16px;
  margin-left: auto;
  margin-right: auto;
`
const ContactLink = styled.div`
  font-size: 1.2rem;
  color: ${props => props.theme.shade[0]};
  span {
    text-decoration: none;
    font-weight: 600;
    margin-right: 8px;
  }
`
const OrDivider = styled.div`
  margin-top: 64px;
  margin-bottom: 64px;
`

export default function HeroContact({ title }) {
  return (
    <Outer>
      <Inner>
        <TextContainer>
          <Title>{title}</Title>
          <ContactDetails>
            <ContactTitle>Contact Phil Randall (Founder)</ContactTitle>
            <hr />
            <ContactLink>
              <span>Email:</span>
              <a href="mailto:phil.randall@userfy.co.uk">
                phil.randall@userfy.co.uk
              </a>
            </ContactLink>
            <ContactLink>
              <span>Mobile:</span>
              <a href="tel:07712669935">07712669935</a>
            </ContactLink>
            <ContactLink>
              <span>Office:</span>
              <a href="tel:0115 7722532">0115 7722532</a>
            </ContactLink>
          </ContactDetails>
          <OrDivider>or</OrDivider>
          <ContactDetails>
            <ContactTitle>Use our contact form</ContactTitle>
            <hr />
            <Form />
          </ContactDetails>
        </TextContainer>
      </Inner>
    </Outer>
  )
}
